import { useRef, useCallback } from "react";

export type TutorialRefMap = Record<string, HTMLElement | null>;

export const useTutorialRefs = () => {
  const refs = useRef<TutorialRefMap>({});

  const setRef = useCallback((key: string) => {
    return (el: HTMLElement | null) => {
      refs.current[key] = el;
    };
  }, []);

  const getRef = useCallback((key: string): HTMLElement | null => {
    return refs.current[key] ?? null;
  }, []);

  const getElementByStep = useCallback(
    (targetSelector?: string, targetRefKey?: string): HTMLElement | null => {
      if (targetRefKey) {
        const el = getRef(targetRefKey);
        if (el) return el;
      }
      if (targetSelector) {
        return document.querySelector<HTMLElement>(targetSelector);
      }
      return null;
    },
    [getRef]
  );

  return { setRef, getRef, getElementByStep };
};

export default useTutorialRefs;
